import { Component, DoCheck, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EvaluationService } from '../../evaluation.service';
import { ValidationService } from '../../validation.service';
import { AuthService } from 'src/app/auth.service';
import { Command, NavbarService } from 'src/app/navbar.service';
import { isB, isG, isM } from 'src/app/data-model';
import { Subject } from 'rxjs';
import { ProjectService } from 'src/app/project.service';

@Component({
    standalone: false,
    template: '',
    styles: [''],
    
})
export class HlAreaComponent implements OnInit, OnDestroy, DoCheck {
  @Input() sbj = new Subject<any>;
  data?: any;

  constructor(
    public vs: ValidationService,
    private aus: AuthService,
    private ps: ProjectService,
    protected es: EvaluationService,
    private ns: NavbarService,
    private router: Router,
		private route: ActivatedRoute,
	) {
		this.sbj.subscribe((bp: any) => {
			this.data = bp;
			this.es.setContext(bp);
			this.vs.setContext(bp)
		});
	}

	ngOnInit() {
		this.route.parent?.data.subscribe(data => {
			this.sbj.next(data['bp']);
		});
		this.aus.authChanged.subscribe(() => this.initButtons());
		this.initButtons();
  }
	
	ngOnDestroy() {
		this.ns.unsubscribe(Command.commentTools);
	}

  ngDoCheck(): void {
		this.vs.setValidationState();
	}

	initButtons() {
		if (this.ps.canI('write', 'comments')) {
			this.aus.commenting = this.ps.amI('kontrolleur');
			this.ns.subscribe(Command.commentTools, () => {});
		}
		else {
			this.ns.unsubscribe(Command.commentTools);
		}		
	}
	
  onClose() {
    this.router.navigate(['/bohrpunkte', this.data!._id]);
  }

  isB(): boolean {
    return isB(this.data);
  }

  isG(): boolean {
    return isG(this.data);
  }

  isM(): boolean {
    return isM(this.data);
  }

  /** Prüft ob Kartierer/Datum angezeigt werden darf (nicht für Gäste und nicht-angemeldete) */
  canSeePersonalData(): boolean {
    return this.aus.isAuthenticated.getValue() && !this.aus.amI('gast');
  }
}
